import React from "react";
import PropTypes from "prop-types";
import { equals } from "ramda";

import isOLO from "helpers/is_olo";
import { validateCardDetails } from "helpers/validation/forms";

import Button from "components/button";

import EditCreditCardAddress from "components/account/credit_cards/edit_credit_card_address";
import EditCreditCardDetails from "components/account/credit_cards/edit_credit_card_details";
import CreditCardSubmissionFrame from "components/online_ordering/checkout/credit_card_submission_frame";

class EditCreditCard extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePaymentMethodToken = this.handlePaymentMethodToken.bind(this);
  }

  componentDidMount() {
    if (isOLO()) {
      window.addEventListener("message", this.handlePaymentMethodToken);
    }
  }

  componentWillUnmount() {
    if (isOLO()) {
      window.removeEventListener("message", this.handlePaymentMethodToken);
    }
  }

  handlePaymentMethodToken(event) {
    const { onSaveNewCreditCardWithToken, card } = this.props;
    if (event.data.paymentMethodToken) {
      const { paymentMethodToken } = event.data;

      onSaveNewCreditCardWithToken(card, paymentMethodToken);
    } else if (event.data.paymentError) {
      // TODO add errors message
      console.log(event.data.paymentError);
    }
  }

  handleSubmit() {
    const { onUpdateCard, card, onReturnCardErrors } = this.props;

    if (this.ccFrame && isOLO()) {
      const errors = validateCardDetails(card);
      if (errors) {
        return onReturnCardErrors(card, errors);
      }

      return this.ccFrame.doSubmit();
    }

    return onUpdateCard();
  }

  render() {
    const {
      card,
      storeInfo,
      onCancel,
      onUpdateCreditCardField,
      onBlurValidateCCField,
    } = this.props;

    let creditCardSubmissionFrame;
    if (isOLO()) {
      creditCardSubmissionFrame = (
        <CreditCardSubmissionFrame
          ref={ccFrame => (this.ccFrame = ccFrame)}
          card={card}
          merchantKey={storeInfo.ugMerchantKey}
        />
      );
    }

    return (
      <div className="form expanded-form edit-credit-card">
        <EditCreditCardDetails
          card={card}
          handleUpdateField={onUpdateCreditCardField}
          onBlurValidateCCField={onBlurValidateCCField}
        />
        <EditCreditCardAddress
          card={card}
          handleUpdateField={onUpdateCreditCardField}
          onBlurValidateCCField={onBlurValidateCCField}
        />
        {creditCardSubmissionFrame}
        <div className="buttons">
          <Button
            className="button cancel"
            type="secondary"
            onClick={onCancel}
            size="small">
            Cancel
          </Button>

          <Button
            className="button update"
            type="primary"
            onClick={this.handleSubmit}
            size="small">
            {equals(card.cardUuid, "new-card") ? "Save" : "Update"}
          </Button>
        </div>
      </div>
    );
  }
}

EditCreditCard.propTypes = {
  card: PropTypes.object.isRequired,
  storeInfo: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onUpdateCard: PropTypes.func.isRequired,
  onReturnCardErrors: PropTypes.func.isRequired,
  onBlurValidateCCField: PropTypes.func.isRequired,
  onSaveNewCreditCardWithToken: PropTypes.func.isRequired,
  onUpdateCreditCardField: PropTypes.func.isRequired,
};

export default EditCreditCard;
